import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import urls from 'constants/urls';

import AnchorLink from 'components/AnchorLink';
import PreviousOrderSummary from 'components/PreviousOrderSummary';
import { Typography } from '@johnlewispartnership/wtr-ingredients/foundations/typography';

import styles from 'components/ShopFromRecentOrder/ShopFromRecentOrder.scss';

const ShopFromRecentOrder = ({
  previousOrderId = null,
  listsHubPage = true,
  breakpointClasses,
  analyticsTags,
}) => {
  if (!previousOrderId) return null;
  const ordersUrl = `${urls.myOrdersPage}?wrint=1-YLO-allprevious`;

  return (
    <article
      data-test="ShopFromRecentOrder"
      className={classNames(styles.recentOrder, breakpointClasses, {
        [styles.responsive]: !listsHubPage,
      })}
      {...analyticsTags}
    >
      {/* The internal logic to this component about when the component should render or not needs reviewing. */}
      <Typography element="h2" styleAs="sectionHeadingLight" textStyle="heading-xl">
        Your last order
      </Typography>
      <div className={styles.previousOrderSummary}>
        <PreviousOrderSummary orderId={previousOrderId} />
      </div>
      <AnchorLink className={styles.viewAll} to={ordersUrl}>
        View all previous orders
      </AnchorLink>
    </article>
  );
};

ShopFromRecentOrder.propTypes = {
  analyticsTags: PropTypes.shape({}),
  breakpointClasses: PropTypes.arrayOf(PropTypes.string),
  previousOrderId: PropTypes.string,
  listsHubPage: PropTypes.bool,
};

ShopFromRecentOrder.displayName = 'ShopFromRecentOrder';

export default ShopFromRecentOrder;
